
import React, { useState } from 'react';
import { StorageService } from '../services/db';

interface Props {
  onNavigate: (page: string) => void;
  onAdminEnter: () => void;
}

export const Footer: React.FC<Props> = ({ onNavigate, onAdminEnter }) => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      StorageService.addSubscriber(email);
      alert('Děkujeme za přihlášení k odběru!');
      setEmail('');
    }
  };

  return (
    <footer className="bg-stone-950 text-white pt-24 pb-12 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
        <div className="space-y-6">
          <h3 className="text-xl font-bold uppercase tracking-widest text-white">O nás</h3>
          <p className="text-stone-400 text-sm leading-relaxed">
            Naše společnost se specializuje na prodej a instalaci modulových domů. Nabízíme rychlé, cenově dostupné a efektivní řešení pro vytvoření vlastního bydlení nebo pronájmu.
          </p>
        </div>

        <div className="space-y-6">
          <h3 className="text-xl font-bold uppercase tracking-widest text-white">Kontakty</h3>
          <div className="space-y-4 text-stone-400 text-sm">
            <p className="flex items-center space-x-3">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
              <span>+420 608 099 059</span>
            </p>
            <p className="flex items-center space-x-3">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
              <span>domivka@email.cz</span>
            </p>
            <p className="flex items-center space-x-3">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
              <span>Jáchymovská 42/19, Bohatice 360 04, Karlovy Vary</span>
            </p>
          </div>
        </div>

        <div className="space-y-6">
          <h3 className="text-xl font-bold uppercase tracking-widest text-white">Odkazy</h3>
          <ul className="space-y-3 text-stone-400 text-sm uppercase tracking-wider font-medium">
            <li><button onClick={() => onNavigate('home')} className="hover:text-white transition-colors">O nás</button></li>
            <li><button onClick={() => onNavigate('faq')} className="hover:text-white transition-colors">Časté dotazy</button></li>
            <li><button onClick={() => onNavigate('investment')} className="hover:text-white transition-colors">Kalkulátor ziskovosti</button></li>
            <li><button onClick={() => onNavigate('gallery')} className="hover:text-white transition-colors">Galerie</button></li>
          </ul>
        </div>

        <div className="space-y-6">
          <h3 className="text-xl font-bold uppercase tracking-widest text-white">Newsletter</h3>
          <p className="text-stone-400 text-sm">Přihlaste se k odběru novinek a nabídek.</p>
          <form className="flex" onSubmit={handleSubscribe}>
            <input 
              type="email" 
              placeholder="E-mail" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-white/10 border border-white/10 px-4 py-3 rounded-l-xl w-full focus:outline-none focus:border-white/30" 
              required
            />
            <button type="submit" className="bg-white text-stone-900 px-4 py-3 rounded-r-xl font-bold uppercase text-xs">Přihlásit</button>
          </form>
        </div>
      </div>
      <div className="max-w-7xl mx-auto border-t border-white/5 pt-12 flex flex-col md:flex-row justify-between items-center text-stone-500 text-xs tracking-widest font-bold">
         <button onClick={onAdminEnter} className="hover:text-white">ADMIN PANEL</button>
         <p>© 2025 domivka.cz. Všechna práva vyhrazena.</p>
      </div>
    </footer>
  );
};
